import * as _ from 'lodash';
import { fromJS } from 'immutable';
import * as landModelsActions from '../actions/landModels';
import { SUCCESS, START, ERROR } from '../actions/global';
import { fetchingState } from '@constants';

const initialState = {
  allYears: {
    data: [],
    state: null,
  },
  methods: {
    data: [],
    state: null,
  },
  modelLands: {},
  modelLand: {},
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case landModelsActions.FETCH_ALL_YEARS[START]: {
      return state.setIn(['allYears', 'state'], fetchingState.FETCHING);
    }
    case landModelsActions.FETCH_ALL_YEARS[ERROR]: {
      return state.setIn(['allYears', 'state'], fetchingState.ERROR);
    }
    case landModelsActions.FETCH_ALL_YEARS[SUCCESS]: {
      return state
        .setIn(['allYears', 'state'], fetchingState.LOADED)
        .setIn(
          ['allYears', 'data'],
          fromJS(_.get(action, ['data', 'results'], [])),
        );
    }

    case landModelsActions.FETCH_MODEL_LAND_METHODS[START]: {
      return state.setIn(['methods', 'state'], fetchingState.FETCHING);
    }
    case landModelsActions.FETCH_MODEL_LAND_METHODS[ERROR]: {
      return state.setIn(['methods', 'state'], fetchingState.ERROR);
    }
    case landModelsActions.FETCH_MODEL_LAND_METHODS[SUCCESS]: {
      return state
        .setIn(
          ['methods', 'data'],
          fromJS(_.get(action, ['data', 'results'], [])),
        )
        .setIn(['methods', 'state'], fetchingState.LOADED);
    }

    case landModelsActions.FETCH_MODEL_LANDS[START]: {
      return state.setIn(
        ['modelLands', action.method, 'state'],
        fetchingState.FETCHING,
      );
    }
    case landModelsActions.FETCH_MODEL_LANDS[ERROR]: {
      return state.setIn(
        ['modelLands', action.method, 'state'],
        fetchingState.ERROR,
      );
    }
    case landModelsActions.FETCH_MODEL_LANDS[SUCCESS]: {
      return state
        .setIn(
          ['modelLands', action.method, 'data'],
          fromJS(_.get(action, ['data', 'results'], [])),
        )
        .setIn(['modelLands', action.method, 'state'], fetchingState.LOADED);
    }

    case landModelsActions.FETCH_MODEL_LAND[START]: {
      return state.setIn(
        ['modelLand', action.method, 'state'],
        fetchingState.FETCHING,
      );
    }
    case landModelsActions.FETCH_MODEL_LAND[ERROR]: {
      return state.setIn(
        ['modelLand', action.method, 'state'],
        fetchingState.ERROR,
      );
    }
    case landModelsActions.FETCH_MODEL_LAND[SUCCESS]: {
      return state
        .setIn(
          ['modelLand', action.method, 'data'],
          fromJS(_.get(action, ['data', 'results', '0'], {})),
        )
        .setIn(['modelLand', action.method, 'state'], fetchingState.LOADED);
    }

    case landModelsActions.FETCH_MODEL_LAND_RANGES[START]: {
      return state.setIn(
        ['modelLand', action.method, 'ranges', 'state'],
        fetchingState.FETCHING,
      );
    }
    case landModelsActions.FETCH_MODEL_LAND_RANGES[ERROR]: {
      return state.setIn(
        ['modelLand', action.method, 'ranges', 'state'],
        fetchingState.ERROR,
      );
    }
    case landModelsActions.FETCH_MODEL_LAND_RANGES[SUCCESS]: {
      return state
        .setIn(
          ['modelLand', action.method, 'ranges', 'state'],
          fetchingState.LOADED,
        )
        .setIn(
          ['modelLand', action.method, 'ranges', 'data'],
          fromJS(_.get(action, ['data', 'results'], [])),
        );
    }

    case landModelsActions.APPLY_ADJUSTMENT_FACTOR[START]: {
      return state.setIn(
        ['modelLand', action.method, 'ranges', 'state'],
        fetchingState.FETCHING,
      );
    }
    case landModelsActions.APPLY_ADJUSTMENT_FACTOR[ERROR]: {
      return state.setIn(
        ['modelLand', action.method, 'ranges', 'state'],
        fetchingState.ERROR,
      );
    }
    case landModelsActions.APPLY_ADJUSTMENT_FACTOR[SUCCESS]: {
      return state.setIn(
        ['modelLand', action.method, 'ranges', 'state'],
        fetchingState.LOADED,
      );
    }

    case landModelsActions.FETCH_MODEL_LAND_PRICING_SCHEDULES[START]: {
      return state.setIn(
        ['modelLand', action.method, 'pricingSchedules', 'state'],
        fetchingState.FETCHING,
      );
    }
    case landModelsActions.FETCH_MODEL_LAND_PRICING_SCHEDULES[ERROR]: {
      return state.setIn(
        ['modelLand', action.method, 'pricingSchedules', 'state'],
        fetchingState.ERROR,
      );
    }
    case landModelsActions.FETCH_MODEL_LAND_PRICING_SCHEDULES[SUCCESS]: {
      return state
        .setIn(
          ['modelLand', action.method, 'pricingSchedules', 'state'],
          fetchingState.LOADED,
        )
        .setIn(
          ['modelLand', action.method, 'pricingSchedules', 'data'],
          fromJS(_.get(action, ['data', 'results'], [])),
        );
    }

    case landModelsActions.DELETE_MODEL_LAND_PRICING_SCHEDULE[SUCCESS]: {
      let list = state
        .getIn(['modelLand', action.method, 'pricingSchedules', 'data'])
        .toJS()
        .filter(
          e =>
            e[
              `model${
                action.method === 'LOT' ? 'Lot' : action.method
              }PricingScheduleID`
            ] !== action.id,
        );

      return state.setIn(
        ['modelLand', action.method, 'pricingSchedules', 'data'],
        fromJS(list),
      );
    }

    case landModelsActions.INSERT_MODEL_LAND_PRICING_SCHEDULE[SUCCESS]:
    case landModelsActions.SET_MODEL_LAND_PRICING_SCHEDULE_BASE[SUCCESS]: {
      return state.setIn(
        ['modelLand', action.method, 'pricingSchedules', 'data'],
        fromJS(_.get(action, ['data', 'results'], [])),
      );
    }

    default: {
      return state;
    }
  }
};
